export default __webpack_public_path__ + "static/media/jquery.429008ec.svg";